import { StyleSheet } from "react-native"
import { ReactNode } from "react"
import { LinearGradient } from "../LinearGradient/LinearGradient"

type LinearGradientWrapperProps = {
  children: ReactNode
  gradientEnd: number
  colors?: (string | number)[]
}

export function LinearGradientWrapper(props: LinearGradientWrapperProps) {
  const { children, gradientEnd, colors = ["#BECBFD", "#ffffff"] } = props

  return (
    <LinearGradient
      colors={colors}
      style={styles.linearGradient}
      start={{ x: 0.0, y: 0.0 }}
      end={{ x: 0.0, y: gradientEnd }}
    >
      {children}
    </LinearGradient>
  )
}

const styles = StyleSheet.create({
  linearGradient: {
    flex: 1,
    backgroundColor: "white",
  },
})
